import { mapState } from 'vuex';
import dataex from './dataex.js';

import atext from '@/components/wai/atext/index.vue'
import biblist from '@/components/wai/biblist/index.vue'
import authors from '@/components/wai/authors/index.vue'

export default {
    name: 'waiarticle',
    props: {
        sha : String,
        cuis : Array
    },

    components: {
        atext : atext,
        biblist : biblist,
        authors : authors
    },

    data : function(){

        return {
            loading : false,
            data : null,
            current : null
        }

    },

    watch: {
        sha : function(){
            this.load()
        },
        cuis: function(){
            this.load()
        },
    },

    created : function(){

        this.load()

    },

    mounted: function(){


        var s = this.$f.scrollTo

        var t = this

        $(this.$el).on('click', '.ref', function(){

            var a = $(this).attr('to')

            if(a){
                s($(t.$el).find('#' + a))
            }

        })

        /*this.$refs['mydiv'].firstChild.addEventListener('click', function(event) {
          event.preventDefault();
          console.log('clicked: ', event.target);
        })*/
    },

    beforeRouteEnter (to, from, next) {
        next()
    },

    beforeRouteUpdate (to, from, next) {
        next()
    },

    computed: mapState({
        auth : state => state.auth,

       
    }),

    methods : {
        load : function(){


            this.loading = true

            if(!this.cuis) return null
            if(!this.sha) return null


            var cdata = null
            var cuisdata = null;

            this.data = null

            this.$root.api.wai.info.cui({

                cui : this.cuis

            }).then(results => {

                cdata = results.data
                
                return this.$root.api.wai.article.cuis({

                    sha : this.sha,
                    cuis : JSON.stringify(this.cuis)
    
                })

            }).then(results => {

                cuisdata = results.data

                var t = this

                cuisdata = _.map(cuisdata, function(d){

                    return {
                        type : d.type,
                        cui : d.CUI,
                        start : d.PosBeg,
                        end : d.PosEnd + 1,
                        num : d.num,
                        id : t.$f.makeid(true),
                        t : 'cui'
                    }
                })

                cuisdata = _.sortBy(cuisdata, function(c){
                    return c.start
                })

                return this.$root.api.external.article(this.sha)

            }).then(results => {

                
                    this.loading = false

                    this.data = results

                    var d = this.data.cuis = {}

                    _.each(cdata, function(c){
                        d[c.CUI] = c
                    })


                    _.each(this.data.body_text, function(bt, i){

                        bt.cuis = _.filter(cuisdata, function(d){

                            return d.type == 'bd' && d.num == i + 1

                        })

                    })

                    _.each(this.data.abstract, function(bt, i){

                        bt.cuis = _.filter(cuisdata, function(d){

                            return d.type == 'ab' && d.num == i + 1

                        })

                    })

                    console.log('this.data', this.data)
                

                
                if (this.loading){
                    //this.data = results.data
                }
                else{
                    
                }

            }).catch(error => {
           
                console.log("ERROR", error)

            })

            return

            this.$root.api.external.article(this.sha).then(results => {


                if (this.loading){
                    this.loading = false

                    this.data = results.data
                }
                else{
                    
                }

            }).catch(error => {

                console.log(error)

                if (this.loading){
                    this.loading = false
                }
                else{

                }                

            })

           

        }
    },
}